<template>
	<notifications classes="notify" position="top right"/>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.notification {
	&.notify {
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
		font-size: 0.9em;
		padding: 1em;
		margin: 1em;
		margin-bottom: 0em;
		background-color: #636464;
		border-left: 6px solid #000;
		color: $white1;
	}

	&-title {
		margin-bottom: 0.5em;
	}
	&-content {
		font-size: 14px;
	}
}
</style>
